module.exports = __webpack_public_path__ + "img/ChinaMobile.237df8bc.png";